(function() {
    'use strict';

    angular
        .module('atheer.insights')
        .controller('InsightsConversationController', InsightsConversationController);

    /* @ngInject */
    function InsightsConversationController($scope, $q, $translate, $filter, Report, CONTENT_META, triSettings, Workspace, workspaceId) {
        var vm = this;

        vm.primaryColor = triSettings.getSkinModel().primary_color_hex;
        vm.secondaryColor = triSettings.getSkinModel().secondary_color_hex;
        vm.loadingData = false;
        vm.dashboardModel = null;
        vm.illustartionEmptyScreenId = "insight_graph";

        vm.topUsersByConversationCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.topUsersByConversationCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfConversations')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.conversations.title'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.topUsersByMessageCount = {
            chart: {
                type: 'bar',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.topUsersByMessagCount')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfMessages')
                },
                allowDecimals: false
            },
            xAxis: {
                title: {
                    text: $translate.instant('atheer.insights.users.title')
                },
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.conversations.messages'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        vm.messageUsageByDay = {
            chart: {
                type: 'column',
            },
            title: {
                text: $translate.instant('atheer.insights.conversations.messagesPerDay')
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            yAxis: {
                title: {
                    text: $translate.instant('atheer.insights.conversations.noOfMessages')
                },
                allowDecimals: false
            },
            xAxis: {
                categories: [],
                labels: {
                    enabled: true
                }
            },
            plotOptions: {
                series: {
                    stacking: 'normal'
                }
            },
            series: [{
                name: $translate.instant('atheer.insights.dates'),
                color: vm.primaryColor,
                data: []
            }],
            tooltip: {
                formatter: function() {
                    return '<b>' + this.series.name + '</b> : ' + this.y + ' ' + this.x;
                }
            }
        };

        function performDataProcess() {
            vm.dashboardModel.avg_messages_per_conversation = Math.ceil(vm.dashboardModel.avg_messages_per_conversation);
            angular.forEach(vm.dashboardModel.top_users_by_conversation_count, function(topUsersByConversationCount) {
                vm.topUsersByConversationCount.xAxis.categories.push(topUsersByConversationCount.name);
                vm.topUsersByConversationCount.series[0].data.push(topUsersByConversationCount.count);
            });

            angular.forEach(vm.dashboardModel.top_users_by_message_count, function(topUsersByMessageCount) {
                vm.topUsersByMessageCount.xAxis.categories.push(topUsersByMessageCount.name);
                vm.topUsersByMessageCount.series[0].data.push(topUsersByMessageCount.count);
            });

            angular.forEach(vm.dashboardModel.message_usage_by_day, function(messageUsageByDay) {
                vm.messageUsageByDay.xAxis.categories.push(messageUsageByDay.name);
                vm.messageUsageByDay.series[0].data.push(messageUsageByDay.count);
            });

            vm.loadingData = false;
        }

        vm.loadData = function() {
            vm.loadingData = true;

            var resource = angular.isDefined(workspaceId) ? Workspace.getConversationDashboard({
                id: workspaceId
            }).$promise : Report.getConversationDashboard().$promise;

            $q.all([
                    resource
                ])
                .then(function(results) {
                    vm.dashboardModel = results[0];
                    performDataProcess();
                });
        }

        vm.loadData();
    }
})();
